import { SideMenuLink } from '@amzn/meridian/side-menu';
import Text from '@amzn/meridian/text';
import { getMicroFrontendName, getMicroFrontendPath, MicroFrontend, MicroFrontends, MicroFrontendSubModules } from '@amzn/rangoli-seller-desktop-utils/src/index';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { helpAndSupportStore } from '../../store/HelpAndSupportStore';
import { sidebarStore } from '../../store/SidebarStore';
import SidebarChildMenuLink from './SidebarChildMenuLink';
import Row from '@amzn/meridian/row';
import { parentSideMenuColor } from '../../Style/Style';
import Theme from '@amzn/meridian/theme';
import { sidemenuTextColorToken } from '../../Style/tokens';

export interface SidebarMenuLinkProps {
  MicroFrontendsKey?: MicroFrontends;
  children?: React.ReactNode;
  selectedGroupedSidebar?: string;
  toggleSelectedGroupedSidebar?: (sideBarItem: string) => void;
  title?: string;
  icon:string;
}

const getChildModule = (parentModule) => {
  switch (parentModule) {
    case "catalog":
      return "/catalog/products";
    case "orders":
      return "/orders";
    case "analytics":
      return "/analytics/sales";
    case "reviews":
      return "/reviews/manage";
    case "store configuration":
      return "/store-appearance";
    case "growth":
      return "/offers";
  }
};

const SidebarMenuLink = ({
  MicroFrontendsKey,
  children,
  toggleSelectedGroupedSidebar,
  selectedGroupedSidebar,
  title,
  icon,
}: SidebarMenuLinkProps) => {
  const navigate = useNavigate();
  const { handleChangeActiveProfileDetails } = helpAndSupportStore;
  const { setSidebarToggle, setParentRoute, parentRoute } = sidebarStore;
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const childPath: string = title ? title.toLowerCase() : getMicroFrontendPath(MicroFrontendsKey);
  const isGroupedSidebarSelected = selectedGroupedSidebar === childPath;
  const isSelectedSidebar = (): boolean => childPath === parentRoute;
  const handleOnClickNavigation = (): void => {
    if (children) {
      toggleSelectedGroupedSidebar(childPath);
      const navigatePath = getChildModule(childPath);
      if(selectedGroupedSidebar === childPath) {
        setIsSidebarOpen((prev) => !prev);
      }
      navigate(navigatePath);
    } else {
      setParentRoute(childPath);
      const navigatePath = getMicroFrontendPath(MicroFrontendsKey);
      navigate(navigatePath);
      handleChangeActiveProfileDetails(false);
      setSidebarToggle();
    }
  };

  return (
    <Theme tokens={sidemenuTextColorToken}>
      <SideMenuLink
        onClick={handleOnClickNavigation}
        href={getMicroFrontendPath(MicroFrontendsKey)}
        linkComponents={[SidebarChildMenuLink]}
        selected={isSelectedSidebar()}
        open={isGroupedSidebarSelected && isSidebarOpen}
      >
          <Row spacing="300"> 
            <Theme tokens={sidemenuTextColorToken}>
            <Text type="b200" className={parentSideMenuColor}>{title? title : getMicroFrontendName(MicroFrontendsKey)}</Text>
            </Theme>
            <img src={icon}/> 
          </Row>
          {children}
      </SideMenuLink>
    </Theme>
  );
};

export default observer(SidebarMenuLink);
